(function() {
    'use strict';

    angular.module( APP_ID )
        .constant( 'TEXTS', TextsLibrary() );

    //TODO: Refactor naming and categorisation before adaptation to Squiz API

    /**
     * Library with all texts and strings used across the app.
     *
     * To use one or more parameters, add
     * `{{ p[0] }}`, `{{ p[1] }}` ... `{{ p[n] }}` to the string.
     */
    function TextsLibrary( ) {
        var urls = baseConfig.env.urls,

        texts = {
            'TITLE': {
                'DEFAULT': "Victoria University of Wellington"
            },
            'DESCRIPTION': {
                'DEFAULT': "at Victoria University of Wellington (VUW)"
            },
            'KEYWORDS': {
                'DEFAULT': "subject areas, degrees, find, choose, explore, undergraduate, postgraduate, Victoria, university, Wellington, New Zealand, Master's, study"
            },
            'NOTIFICATIONS': {
                'SERVER_ERROR_META_TITLE':        "Unexpected error (#500)",
                'SERVER_ERROR_META_DESCRIPTION':  "Page could not be loaded due to issues on our server (#500 Internal server error)",
                'LOADING_LABEL':            "Loading ...",
                'LOADING_DESCRIPTION':      "The application is loading, please wait.",
                'ERROR_LABEL':              "Sorry, something went wrong",
                'ERROR_FEEDBACK_INSTRUCTIONS': "If you believe this should not happen, please <a title='Inform us about the problem you encountered' href='" + urls.website + "/feedback'>let us know</a> about the issue.",
                'ERROR_RESPONSE_CODE':      "Response code:",
                'ERROR_BUTTON_CTA_LABEL':   "Explore subject areas",
                'ERROR_BUTTON_CTA_TITLE':   "Try to find different area you can study"
            },
            'SHARED': {
                'INTRO': {
                    'REFERRER_LEAD': "Find out more about studying {{ p[ 0 ] }} at Victoria University of Wellington",
                    'REFERRER_LEAD_PROFESSIONAL_POSTGRAD': "Find out more about studying in this field at Victoria University of Wellington"
                },
                'FEES': {
                    'HEADING': {
                        'INTERNATIONAL':        "Estimated international fees",
                        'DOMESTIC':             "Estimated domestic fees",
                    },
                    'HEADING_TOOLTIP_INTERNATIONAL': "This fee estimate doesn't include your student service fees.",
                    'SUBHEADING_TUITION':           "About",
                    'LABEL_LEVIES':                 "student service fees",
                    'LABEL_EXTRA_COSTS':            "additional costs",
                    'LABEL_COURSE_FEES':            "course costs",
                    'LABEL_CONVERSION':             "Approximately",
                    'LABEL_NOTE_INTERNATIONAL':     "You will also pay an annual <a href=\"https://www.wgtn.ac.nz/students/money/fees/student-services-levy\" title=\"All applicable fees\">student services fees</a>, based on the number of points you enrol in and whether you are studying inside or outside New Zealand.",
                    'LABEL_LEADING_EXCHANGE_RATE':  "at today's",
                    'LABEL_PERIOD_PROGRAMME_PREPEND': "for the",
                    'LABEL_EXCHANGE_RATE':          "exchange rate*",
                    'TOOLTIP_EXCHANGE_RATE':        "*This currency conversion is for informational purposes only. All fees are invoiced in New Zealand dollars",
                    'STUDY_ABROAD_PREFIX':          "Study Abroad students:",
                    'STUDENTS_EXCHANGE_DISCLAIMER': "Exchange students: <strong>Continue paying your home institution tuition fees</strong>",

                    'MINIFIED': {
                        'LABEL':    "Fees",
                        'TBA':      "TBA",
                        'TOOLTIP':  "Estimated student fees of {{:: p[ 0 ] }} course costs{{:: p[ 1 ] && p[ 1 ] !== 'NZ$0' ? ' + ' + p[ 1 ] + ' additional costs' : '' }}{{:: p[ 2 ] && p[ 2 ] !== 'NZ$0' ? ' + ' + p[ 2 ] + ' student service fees' : '' }}.",
                        'TOOLTIP_INTERNATIONAL':        "This fee estimate doesn't include your student service fees.",
                        'STUDY_ABROAD_PREFIX':          "Study Abroad students:",
                        'STUDENTS_EXCHANGE_DISCLAIMER': "<strong>Exchange students:</strong> Continue paying your home institution fees"
                    },

                    'SELECTOR_COUNTRY_DEFAULT':     "Choose preferred currency",

                    'LINK_FEES_CALCULATOR_LABEL':   "Calculate your total yearly costs",
                    'LINK_FEES_CALCULATOR_TITLE':   "Use fees calculator to calculate yearly expenses",

                    'CALCULATION_IN_PROGRESS':      "The costs for this degree are still being calculated.",

                    'ERROR': "We are currently unable to display fees for this programme. Please try again later or <a href=\"" + urls.website + "/international/contact\" title=\"Contact International advisors\">contact Wellington University International</a>."
                },
                'KEY_DATES': {
                    'SUBHEADING_TRIMESTER':     "Trimester {{ p[0] }}",
                    'APPLY_BY_PRETEXT':         "Apply by",
                    'HEADING':                  "Key dates",
                    'START_STUDY_PRETEXT':      "to start studying",
                    'START_STUDY_SHORT_PRETEXT': "to start",
                    'SUBHEADING_CUSTOM':        "This programme",
                    'SUBHEADING_ANYTIME':       "Flexible",
                    'VALUE_ANYTIME':            "Any time",
                    'LIMITED_ENTRY_TOOLTIP':    "Enrolment deadline for limited entry courses is 1 December.",
                    'LATE_APPLY':               "Late application possible",
                    'LINK_SHOW_MORE_LABEL':     "Show next {{ p[0] }} starting dates",
                    'LINK_SHOW_MORE_TITLE':     "Show {{ p[0] }} more starting dates"
                }
            },
            'GENERIC': {
                'BANNER': {
                    'TOOLTIP_DURATION': "Usual duration to complete qualification",
                    'TOOLTIP_LOCATION': "Primary location of study",
                    'TOOLTIP_KEY_DATES': "Next opportunity to start studying",
                    'LABEL_APPLY_BY': "Apply by",
                    'LABEL_START_BY': "to start",
                    "PROGRAMME_DURATION_SUFFIX": 'trimester{{ p[0] }}'
                },
                'NAVIGATION_TABS': {
                    'ACCESSIBILITY_LABEL': "Tabbed menu for the main content",
                    'BTN_TOP_TITLE': "Go to the top of the page"
                },
                'CONTENT_ANCHORS': {
                    'HEADING':      "Jump to:",
                    'ANCHOR_TITLE_PREFIX': "Scroll to",
                    'ANCHOR_MAJORS_LABEL': "Major requirements"
                },
                'BUTTONS': {
                    'NEXT_LABEL':     "Next",
                    'NEXT_TITLE':     "Continue to the {{ p[0] }}",

                    'PREVIOUS_LABEL': "Previous",
                    'PREVIOUS_TITLE': "Get back to the {{ p[0] }}"
                },
                'LINKS': {
                    'SEND_MAIL_TITLE':  "Write e-mail to the",
                    'CALL_NUMBER_TITLE': "Make a call to the",
                },
                'TAGS': {
                    'UG_LABEL': "Undergraduate",
                    'UG_TITLE': "Subject is available at the Undergraduate level",
                    'PG_LABEL': "Postgraduate",
                    'PG_TITLE': "Subject is available at the Postgradute level",
                    'PREDEGREE_LABEL': "Pre-degree",
                    'PREDEGREE_TITLE': "Subject is available as the Pre-degree level"
                },
                'COPYRIGHT': "Copyright &copy; Victoria University of Wellington, New Zealand, 2021",
                'FEEDBACK_LINK': {
                    'LABEL': "Give us your feedback",
                    'TITLE': "Tell us what you think or report a problem",
                    'URL': "" + urls.website + "/feedback"
                },
                'FEEDBACK_POPUP': {
                    'HEADING':          "Got a minute?",
                    'CATCHER_TEXT':     "Help us improve this page.",
                    'BUTTON_OK_LABEL':  "Yes, sure",
                    'BUTTON_OK_TITLE':  "Give us a feedback",
                    'BUTTON_NO_TITLE':  "Do not show a feedback",
                },
                'QUOTE': {
                    'PORTRAIT_ALT':         "portrait photo",
                    'BUTTON_MORE_LABEL':    "Full story",
                    'BUTTON_MORE_TITLE':    "Read full story",
                    'BUTTON_STAFF_LABEL':   "Staff profile",
                    'BUTTON_STAFF_TITLE':   "See full staff profile"
                },
                'PEOPLE': {
                    'BUTTON_STAFF_PROFILE_LABEL':   "Staff profile",
                    'BUTTON_STAFF_PROFILE_TITLE':   "Staff profile and contact details",
                    'PORTRAIT_ALT':                 "portrait photo",
                },
                'VIDEO': {
                    'COVER_IMAGE_ALT':      "Video preview",
                    'BUTTON_PLAY_TITLE':    "Play video"
                },
                'COLLAPSIFY': {
                    'LINK_SHOW_MORE_LABEL': "Show more",
                    'LINK_SHOW_MORE_TITLE': "Expand to see all information",
                    'LINK_SHOW_LESS_LABEL': "Hide",
                    'LINK_SHOW_LESS_TITLE': "Collapse block",
                },
                'SLIDE_SHOW': {
                    'BUTTON_NEXT_TITLE': "Show next image",
                    'BUTTON_PREV_TITLE': "Show previous image"
                },
                'REQUIREMENTS': {
                    'SHOW_MORE_LABEL': "Show all requirements",
                    'SHOW_MORE_TITLE': "Expands to show all requirements",
                    'COURSE_LINK_TITLE_PREFIX':         "Details of course",
                    'COURSE_RANGE_LINK_TITLE_PREFIX':   "Show all the courses for"
                },
                'STAFF_LIST': {
                    'LINK_STAFF_PROFILE_TITLE': "'s profile"
                },
                'SUMMARY_CARD_WIDE': {
                    'LABEL_DURATION':           "Duration",
                    'LABEL_LOCATION':           "Location",
                    'LABEL_POINTS':             "Complete",
                    'LABEL_ENTRY_REQUIREMENTS': "Entry",
                    'LABEL_PRETEXT_SUBLINKS':   "or",
                    'LINK_LABEL_REQUIREMENTS':  "requirements and courses",
                    'LINK_TITLE_REQUIREMENTS':  "Requirements and courses in",
                    'POINTS_APPENDIX':          "points",

                    'LABEL_NEXT_START_DATE':    {
                        'ONE':  "Next starting date",
                        'MANY': "Next starting dates"
                    },

                    'COURSES_APPENDIX': {
                        'ONE':  "course",
                        'MANY': "courses"
                    }
                }
            },
            'NOT_FOUND': {
                'META': {
                    'TITLE':        "Page not found (#404)",
                    'DESCRIPTION':  "The page on this URL does not exist (#404 - Page not found)"
                },
                'DEFAULT': {
                    'TYPE':        "page",
                    'HINT':         ""
                },
                'STUDY_AREA': {
                    'TYPE':        "study area",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/subjects' title='Browse all available subject areas'>Browsing all subject areas</a>"
                },
                'DEGREE': {
                    'TYPE':        "degree",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/undergraduates/bachelors-degrees' title='Browse all available degrees'>Browsing all degrees</a>"
                },
                'POSTGRAD': {
                    'TYPE':        "postgraduate programme",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/postgraduates' title='Browse all available postgraduates'>Browsing all postgraduate programmes</a><ul>"
                },
                'POSTGRAD_AREA': {
                    'TYPE':        "postgraduate subject",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/postgraduate-subjects' title='Browse all available postgraduate subjects'>Browsing all postgraduate subjects</a>"
                },
                'GRADUATE_QUAL': {
                    'TYPE':        "graduate qualification",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/postgraduates/graduate-certificates-diplomas' title='Browse all available graduate qualifications'>Browsing all graduate qualifications</a>"
                },
                'OTHER_QUAL': {
                    'TYPE':        "qualification",
                    'HINT':         "<a class='btn' href='" + urls.website + "/study/programmes-courses/short-courses' title='Browse all available pre-degree courses and other programmes'>Browsing all other qualifications</a>"
                }
            },
            'HEADER': {
                'MENU_BUTTON_OPEN_TITLE':        "Open main menu and search",
                'MENU_BUTTON_CLOSE_TITLE':       "Close main menu and search",

                'BREADCRUMBS': {
                    'HOME_TITLE':       "Victoria University of Wellington homepage",
                    'HOME_LABEL':       "Home",
                    'STUDY_TITLE':      "Studying at Victoria University of Wellington",
                    'STUDY_LABEL':      "Future students",
                    'PROGRAMMES_TITLE': "Programmes and courses available",
                    'PROGRAMMES_LABEL': "Programmes and courses",
                    'DEGREES_TITLE':    "All undergraduate degrees",
                    'DEGREES_LABEL':    "Undergraduate degrees",
                    'GRADQUAL_TITLE':  "All graduate certificates and diplomas",
                    'GRADQUAL_LABEL':  "Graduate certificates and diplomas",
                    'PROGRAMME_TITLE':  "All postgraduate degrees",
                    'PROGRAMME_LABEL':  "Postgraduate degrees"
                },

                'SEARCH_BUTTON_TITLE':      "Toggle search",
                'SEARCH_INPUT_LABEL':       "Search term:"
            },
            'EXPLORE': {
                'META_TITLE': "Explore subjects and qualifications",
                'META_DESCRIPTION': "Listing of all available subject areas, postgraduate areas, graudate qualifications, undergraduate degrees and postgraduate programmes",
                'API_ERROR': "Sorry, the API request has failed and we did not get the response. Message: "
            },
            'AREA': {
                'META_TITLE': {
                    'ABOUT':    null,
                    'STUDY':    "Study options",
                    'PEOPLE':   "People"
                },
                'META_DESCRIPTION': {
                    'ABOUT':    "Find out why you should study",
                    'STUDY':    "Discover all degrees and programmes available in the area of",
                    'PEOPLE':    "Read about people studying"
                },
                'MENU': {
                    'ABOUT_LABEL':  "Overview",
                    'ABOUT_TITLE':  "Find out about this area of study",

                    'STUDY_LABEL':  "Study options",
                    'STUDY_TITLE':  "What are your study options in this area?",

                    'PEOPLE_LABEL': "People",
                    'PEOPLE_TITLE': "Other people's stories"
                },
                'BUTTONS': {
                    'STEP_ABOUT_LABEL':  "Overview",
                    'STEP_STUDY_LABEL':  "Study options",
                    'STEP_PEOPLE_LABEL': "People"
                },
                'MORE_INFO': {
                    'FIND_OUT_LABEL': "Find out more:"
                },
                'RELATED_AREAS': {
                    'HEADING': "Related subject areas",
                    'SUBJECTS_SUBHEADING': "Subjects",
                    'BUTTON_SHOW_TITLE': "Show subjects available in",
                    'BUTTON_HIDE_TITLE': "Hide subjects available in",
                    'BUTTON_EXPLORE_AREA_TITLE': "Read why you should study {{ p[ 0 ] }} at Victoria University of Wellington",
                    'BUTTON_EXPLORE_AREA_LABEL': "Explore {{ p[ 0 ] }}"
                },
                'ABOUT_INTRO': {
                    'SUBJECTS_SUBHEADING':              "Subjects",
                    'TAG_UNDERGRAD_ABBREVIATION':       "UG",
                    'TAG_UNDERGRAD_TITLE':              "Undergraduate",
                    'TAG_POSTGRAD_ABBREVIATION':        "PG",
                    'TAG_POSTGRAD_TITLE':               "Postgraduate",
                    'TAG_PREDEGREE_ABBREVIATION':       "Pre-degree",
                },
                'COURSE_EXAMPLES': {
                    'HEADING':         "Example courses",
                    'HEADING_TOOLTIP': "A sample of courses (papers) available at different levels for this subject",
                    'BUTTON_HIDE_TITLE': "Hide the course description",
                    'BUTTON_SHOW_TITLE': "Show the course description"
                }
            },
            'DEGREE': {
                'META_TITLE': {
                    'ABOUT':        null,
                    'REQUIREMENTS': "Requirements",
                    'APPLY':        "Apply"
                },
                'META_DESCRIPTION': {
                    'ABOUT':        "Find out about doing an undergraduate",
                    'REQUIREMENTS': "Check requirements to complete an undergraduate degree in the",
                    'APPLY':        "Check application process to start an undergraduate degree in the"
                },
                'BANNER_SUBTITLE': {
                    'LABEL_ITEMS_INTRO':        "majoring in",
                    'LABEL_ITEMS_CONNECTOR':    "and",
                    'LINK_SET_ITEMS_LABEL':     "Set preferred major",
                    'LINK_SET_ITEMS_TITLE':     "Set major you prefer so we can serve you the most relevant content",
                    'LINK_CHANGE_ITEMS_LABEL':  {
                        'ONE':  "Change major",
                        'MANY': "Change majors"
                    },
                    'LINK_CHANGE_ITEMS_TITLE': {
                        'ONE':  "Change major you prefer so we can serve you the most relevant content",
                        'MANY': "Change majors you prefer so we can serve you the most relevant content"
                    }
                },
                'MENU': {
                    'ABOUT_LABEL': "Overview",
                    'ABOUT_TITLE': "Find out more about this degree",

                    'REQUIREMENTS_LABEL': "Requirements",
                    'REQUIREMENTS_TITLE': "All the requirements for this degree",

                    'APPLY_LABEL': "Applying",
                    'APPLY_TITLE': "How to apply for this degree or contact us"
                },
                'BUTTONS': {
                    'STEP_ABOUT_LABEL':         "Degree overview",
                    'STEP_REQUIREMENTS_LABEL':  "Requirements",
                    'STEP_APPLY_LABEL':         "How to apply"
                },
                'MAJORS': {
                    'HEADING': "Select your majors",
                    'SUBHEADING_SELECTED':  "Major you have selected",
                    'SUBHEADING_OTHERS':    "Other majors",
                    'SUBHEADING_ALL':       "All available majors",
                    'NOTICE': "If you want to do a double major, you may be able to choose your second major from those offered in our other undergraduate degrees. <a href='" + urls.website + "/study/programmes-courses/undergraduate/flexible-study'>Find out more about flexibility in your degree</a>.",
                    'SELECTOR': {
                        'LINK_CLEAR_LABEL': "Clear selection",
                        'LINK_CLEAR_TITLE': "Clear major of the current selection",
                        'SELECTION_PLACEHOLDER': "Choose a major",
                        'SECONDARY_SELECTION_PLACEHOLDER': "Choose another major",
                        'LABEL_COMPACT_PRIMARY':    "Majoring in",
                        'LABEL_COMPACT_SECONDARY':  "and",
                        'DEFAULT_GROUP_LABEL':      "Available majors",
                    },
                    'LINK_SHOW_MORE_LABEL': "Show all other majors",
                    'LINK_SHOW_MORE_TITLE': "Show all majors from this degree"
                },
                'OVERVIEW': {
                    'LABEL_AVAILABLE':      "available",
                    'LABEL_UNDERGRADUATE':  "Undergraduate",
                    'LABEL_PREDEGREE':      "Pre-degree",
                    'LABEL_POSTGRADUATE':   "Postgraduate",
                    'LABEL_MAJORS':         "majors",
                    'LABEL_PREFERRED_MAJORS': "Selected: ",

                    'HEADING_TYPE':           "Level of study",
                    'HEADING_RECOMMENDED_SUBJECTS': "Useful secondary school subjects",
                    'HEADING_ENTRY':          "Entry requirements",
                    'HEADING_LOCATION':       "Location",

                    'MAJORS_SHOW_MORE_LABEL': "Show all",
                    'MAJORS_SHOW_MORE_TITLE': "Show all available majors",

                    'LINK_LABEL_SELECT_MAJORS': "Choose major",
                    'LINK_TITLE_SELECT_MAJORS': "Choose which major you prefer",

                    'LINK_LABEL_CHANGE_MAJORS': "Change major",
                    'LINK_TITLE_CHANGE_MAJORS': "Select different major",

                    'KIS': {
                        'IMAGE_ALT': "Button for easy access to information about this qualification",
                        'LINK_TITLE': "Key Information for Students"
                    }
                },
                'ENTRY_REQUIREMENTS': {
                    'KIS': {
                        'IMAGE_ALT': "Easy access to information about this qualification",
                        'LINK_TITLE': "Key Information for Students"
                    },
                    'HEADING':  "Entry requirements",
                    'ABSTRACT_DOMESTIC': "Requirements for domestic students who studied in",
                    'ABSTRACT_INTERNATIONAL': "Requirements for international students who studied in",

                    'SELECTOR_TITLE':         "Change the country of your last study",
                    'SELECT_COUNTRY_DEFAULT': "Choose the country of last study",

                    'ERROR_INTERNATIONAL': "We are currently unable to display the entry requirements for this programme. Please try again later or <a href=\"" + urls.website + "/international/contact\" title=\"Contact International advisors\">contact Wellington University International</a>.",
                    'ERROR_DOMESTIC': "We are currently unable to display the entry requirements for this programme. Please try again later or <a href=\"" + urls.website + "/study/course-planning/appointments\" title=\"Contact our advisors\">contact Victoria University of Wellington</a>.",
                    'ERROR_INTERNATIONAL_ENGLISH_ONLY': "We are currently unable to display the English proficiency requirements for this programme. Please try again later or <a href=\"" + urls.website + "/international/contact\" title=\"Contact International advisors\">contact Wellington University International</a>.",

                    'LEAD_OR_REQUIREMENTS': "To be accepted into this programme you will need",
                    'LEAD_OR_REQUIREMENTS_MANY': " <strong>one of the following</strong>",

                    'ASTERICS_NOTE': "* <a href=\"" + urls.website + "/international/contact\" title=\"Contact International advisors\">contact Wellington University International</a> for more details on this requirement",

                    'SUBHEADING_ACADEMIC_REQUIREMENTS': "Academic requirements",
                    'SUBHEADING_INTERNATIONAL_APPENDIX':"for international students",
                    'SUBHEADING_ENGLISH':               "Proof of English proficiency"
                }
            },
            'POSTGRAD_AREAS': {
                'META_TITLE': {
                    'ABOUT':            null,
                    'QUALIFICATIONS':   "Qualification options",
                    'PEOPLE':           "People"
                },
                'META_DESCRIPTION': {
                    'ABOUT':            "Study",
                    'QUALIFICATIONS':   "Discover what postgraduate qualifications are available in the",
                    'PEOPLE':           "Find out about the academics you’ll be working with when you study the"
                },
                'MENU': {
                    'ABOUT_LABEL':          "Overview",
                    'ABOUT_TITLE':          "Find out more about this qualification",

                    'QUALIFICATIONS_LABEL': "Qualifications",
                    'QUALIFICATIONS_TITLE': "Postgraduate qualification options",

                    'PEOPLE_LABEL':         "People",
                    'PEOPLE_TITLE':         "Stories of our students and teachers"
                },
                'BUTTONS': {
                    'STEP_ABOUT_LABEL':         "Overview",
                    'STEP_QUALIFICATIONS_LABEL':"Qualification options",
                    'STEP_PEOPLE_LABEL':        "People"
                }
            },
            'POSTGRAD': {
                'META_TITLE': {
                    'ABOUT':        null,
                    'STUDY':        "Study options",
                    'REQUIREMENTS': "Requirements",
                    'PEOPLE':       "People",
                    'APPLY':        "Apply"
                },
                'META_DESCRIPTION': {
                    'ABOUT':        "Find out about doing a",
                    'STUDY':        "How you'll study for a",
                    'REQUIREMENTS': "Requirements to complete a",
                    'PEOPLE':       "Find out about the academics you’ll be working with when studying a",
                    'APPLY':        "How to apply to do a"
                },
                'MENU': {
                    'ABOUT_LABEL':        "Overview",
                    'ABOUT_TITLE':        "Find out more about this qualification",

                    'STUDY_LABEL':        "Study details",
                    'STUDY_TITLE':        "What to expect",

                    'REQUIREMENTS_LABEL': "Requirements",
                    'REQUIREMENTS_TITLE': "See the requirements for this qualification",

                    'PEOPLE_LABEL':       "People",
                    'PEOPLE_TITLE':       "Stories of our students and teachers",

                    'APPLY_LABEL':        "Apply & contact",
                    'APPLY_TITLE':        "How to apply for this qualification or contact us"
                },
                'BUTTONS': {
                    'STEP_ABOUT_LABEL':         "Qualification overview",
                    'STEP_STUDY_LABEL':         "Study details",
                    'STEP_REQUIREMENTS_LABEL':  "Requirements",
                    'STEP_PEOPLE_LABEL':        "People",
                    'STEP_APPLY_LABEL':         "How to apply"
                },
                'SUMMARY_CARD': {
                    'SHOW_MORE_LABEL':  "Show more attributes",
                    'SHOW_MORE_TITLE':  "Expand to see additional attributes",
                    'KIS': {
                        'LINK_LABEL':   "Read more on The Key Information for Students website",
                        'LINK_TITLE':   "Key Information for Students",
                        'IMAGE_ALT':    "Button for easy access to information about this qualification"
                    },
                    'LABELS': {
                        'INTENSITY':          "Intensity",
                        'REQUIREMENTS':       "Complete",
                        'LENGTH':             "Duration",
                        'FEES':               "Fees",
                        'START_TRIMESTER':    "Starts",
                        'SCHEDULE':           "Schedule",

                        'LOCATION':           "Location",
                        'TBA':                "TBA",
                        'TYPE':               "Type",
                        'POINTS':             "points",

                        'ENTRY':              "Entry",

                        'PART_TIME_ONLY':     "Part time only",
                        'FULL_TIME_ONLY':     "Full time only",
                        'PART_AND_FULL_TIME': "Full time or part time",

                        'TRIMESTER': {
                            'ONE': "trimester",
                            'MANY':"trimesters"
                        },

                        'COURSES': {
                            'ONE': "course",
                            'MANY': "courses"
                        }
                    },
                    'TOOLTIPS': {
                        'TRIMESTER_EXPLANATION': "The duration of study for individual students may vary. The University year has three trimesters, starting in March, July and November."
                    },
                    'BUTTONS': {
                        'EXPLORE_LABEL': "Explore the {{ p[ 0 ] }}",
                        'EXPLORE_TITLE': "More about qualification",

                        'VIEW_LABEL': "Courses and requirements",
                        'VIEW_TITLE': "Qualification's courses and requirements details"
                    }
                },
                'INTRO': {
                    'LINK_PHD_TITLE': "See options in",
                    'LINK_SELECTED_QUAL_TITLE': "Show all requirements",
                    'SUBJECT': {
                        'HEADING':          "Available {{ p[0] }}s",
                        'TAG_SELECTED':     "Selected {{ p[0] }}",
                        'SHOW_MORE_LABEL':  "Show all {{ p[0] }}s",
                        'SHOW_MORE_TITLE':  "Expand to see all available {{ p[ 0 ] }}s",
                        'LINK_DETAIL_TITLE':"Set as preferred and show {{ p[ 0 ] }}'s requirements"
                    },
                    'PROGRAMME': {
                        'HEADING':          "Programmes",
                        'TAG_SELECTED':     "Selected programme",
                        'SHOW_MORE_LABEL':  "Show all programmes",
                        'SHOW_MORE_TITLE':  "Expand to see all available programmes",
                        'LINK_DETAIL_TITLE':"Set as preferred and show {{ p[ 0 ] }}'s requirements"
                    },
                    'SPECIALISATION': {
                        'HEADING':          "Specialisations",
                        'TAG_SELECTED':     "Selected specialisations",
                        'SHOW_MORE_LABEL':  "Show all specialisations",
                        'SHOW_MORE_TITLE':  "Expand to see all available specialisation",
                        'LINK_DETAIL_TITLE':"Set as preferred and show {{ p[ 0 ] }}'s requirements"
                    },
                    'DEFAULT': {
                        'HEADING':          "Available qualifications",
                        'TAG_SELECTED':     "Selected qualification",
                        'LINK_DETAIL_TITLE':"Compare {{ p[ 0 ] }} with other related qualifications",
                        'SHOW_MORE_LABEL':  "Show all qualifications",
                        'SHOW_MORE_TITLE':  "Expand to see all available qualifications"
                    }
                },
                'SELECTABLES': {
                    'SUBJECT': {
                        'HEADING':            "Select your subject",
                        'SUBHEADING_OTHERS':  "Other subjects",
                        'SUBHEADING_ALL':     "All available subjects",
                        'SELECTION_HEADLINE': "Available subjects",

                        'LINK_SHOW_MORE_TITLE': "Show all other subjects",
                        'LINK_SHOW_MORE_LABEL': "Show all subjects",

                        'SELECTOR': {
                            'LABEL_COMPACT_PRIMARY':    "Specialising in",
                            'LINK_CLEAR_TITLE':   "Remove subject preference",
                            'LINK_CLEAR_LABEL':   "Cancel selection",
                            'SELECTION_PLACEHOLDER': "Choose a subject"
                        }
                    },
                    'PROGRAMME': {
                        'HEADING':            "Select your programme",
                        'SUBHEADING_ALL':     "All available programmes",
                        'SUBHEADING_OTHERS':  "Other programmes",
                        'SELECTION_HEADLINE': "Available programmes",

                        'LINK_SHOW_MORE_TITLE': "Show all other programmes",
                        'LINK_SHOW_MORE_LABEL': "Show all programmes",

                        'SELECTOR': {
                            'LINK_CLEAR_TITLE':   "Remove programme preference",
                            'LINK_CLEAR_LABEL':   "Cancel selection",
                            'SELECTION_PLACEHOLDER': "Choose a programme"
                        }
                    },
                    'SPECIALISATION': {
                        'HEADING':            "Select your specialisation",
                        'SUBHEADING_OTHERS':  "Other specialisations",
                        'SUBHEADING_ALL':     "All available specialisations",
                        'SELECTION_HEADLINE': "Available specialisations",

                        'LINK_SHOW_MORE_TITLE': "Show all other specialisations",
                        'LINK_SHOW_MORE_LABEL': "Show all specialisations",

                        'SELECTOR': {
                            'LABEL_COMPACT_PRIMARY':    "Specialising in",
                            'LINK_CLEAR_TITLE':   "Remove specialisation preference",
                            'LINK_CLEAR_LABEL':   "Cancel selection",
                            'SELECTION_PLACEHOLDER': "Choose a specialisation"
                        }
                    }
                },
                'APPLY_OVERVIEW': {
                    'HEADING_DATES':            "Key dates",
                    'HEADING_FEES':             "fees",
                    'INTERNATIONAL_WARNING':    "If you are studying at Te Herenga Waka&mdash;Victoria University of Wellington for the first time, or moving from the <a href=\" " + urls.website + "/explore/other-quals/english-academic-purposes/overview\" title=\"English for Academic Purposes (EAP) Pre-degree information\">English for Academic Purposes (EAP)</a> to degree study, you must attend International Orientation and Enrolment prior to the start of your programme. Make sure you check the <a href=\"" + urls.website + "/international/start/orientation-and-enrolment/orientation-and-class-start-dates\" title=\"International orientation dates\">orientation dates</a> for your programme."
                },
                'CONTACT_CARDS': {
                    'INTERNATIONAL_DISCLAIMER': "As an international student, you should contact <a title=\"Contact Wellington University International\" href=\"" + urls.website + "/international/\">Wellington University International</a> with any questions about studying at this university. Wellington University International will also process your application. If you have a query about programme or course content, you can contact one of the academic or school staff below",
                    'CARD_PORTRAIT_TITLE': "{{ p[0] }}'s photo",
                    'CARD_LINK_EMAIL_TITLE': "Send {{ p[0] }} an email"
                }
            },
            'CONTENT_SWITCHER': {
                'DIALOG': {
                    'TITLE':                        "Are you an international student?",
                    'ABSTRACT_MANUALLY':            "Select your nationality below to view information applicable to you. Otherwise you’ll be looking at information for domestic students.",
                    'ABSTRACT_AUTOMATICALLY':       "We think you might be an international student. If so, please select your nationality below to view information applicable to you. Otherwise you'll be looking at information for domestic students.",
                    'NATIONAL_SELECTOR_LABEL':      "I am a citizen of",
                    'NATIONALITY_SELECTOR_DEFAULT': "Choose",

                    'INTERNATIONAL': {
                        'SUBTITLE':            "I'm an international student",
                        'BUTTON_SUBMIT_LABEL': "Show international information",
                        'BUTTON_SUBMIT_TITLE': "Display information for international students",
                        'NATIONALITY_AUSTRALIA_ERROR': "If you are a citizen or resident of Australia who is living in New Zealand, you are considered a domestic student (not an international student).",
                        'NATIONALITY_OTHER_ERROR':   "Citizens and residents of {{ p[0] }} are deemed to be domestic students. We will now display domestic student information to you."
                    },

                    'DOMESTIC': {
                        'SUBTITLE':            "No, I'm a domestic student",
                        'BUTTON_SUBMIT_LABEL': "Show domestic information",
                        'BUTTON_SUBMIT_TITLE': "Display information for domestic students",
                        'MORE_TITLE':          "Get more information",
                        'TOOLTIP_SUBTITLE':    "Citizen and permanent residents of New Zealand, Australia, Cook Islands, Niue, Tokelau are considered domestic students. Also those resident in New Zealand as a consequence of assignment to a diplomatic or consular post."
                    }
                },
                'TOGGLE_LABEL':         "International information",
                'TOGGLE_ON_TITLE':      "Open dialog to switch to information for domestic students",
                'TOGGLE_OFF_TITLE':     "Open dialog to switch to information for international students",
                'TOGGLE_VALUE_ON_LABEL':    "ON",
                'TOGGLE_VALUE_OFF_LABEL':   "OFF"
            },

            /** Structural example - DO NOT USE! */
            'SUBJECT': { 'ONE' : "subject", 'MANY' : "subjects" }
        };

        // Turn Object's attributes into constants!
        Object.freeze( texts );

        return texts;
    }
})();




